export const PNL_REPORT = "PNL_REPORT";
export const PNL_STOCK_DETAILS = "PNL_STOCK_DETAILS";
export const PNL_ERROR = "PNL_ERROR";
export const PNL_SHOW_SHIMMER = "PNL_SHOW_SHIMMER";
export const PNL_HIDE_ERROR = "PNL_HIDE_ERROR";
export const PNL_EMPTY_VALIDATION = "PNL_EMPTY_VALIDATION";
export const PNL_HIDE_EMPTY_VALIDATION = "PNL_HIDE_EMPTY_VALIDATION";
export const PROD_ASSET_FILTER_VAL = "PROD_ASSET_FILTER_VAL";
export const PNL_STREAM_TOGGLE = "PNL_STREAM_TOGGLE";
